import { DEVICE_ENDPOINTS, DeviceLinkCode, DeviceLinkCodeRequest, LinkedDevice } from '@iws/backoffice-api'

import { Model } from '@/clients/http'
import { stringifyGraph } from '@/clients/http/utils'

export type { LinkedDevice }

type ErrorBody = { message?: string }

export class DeviceModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_DEVICE_LIST',
    CREATE_LINK_CODE: 'CREATE_DEVICE_LINK_CODE',
    UNLINK: 'UNLINK_DEVICE',
  }

  public static readonly getList = async () =>
    this.createHttpRequest<{ result: LinkedDevice[]; count: number }, ErrorBody>({
      correlationKey: this.correlations.GET_LIST,
      payload: { method: 'get', url: this.createEndpoint({ url: DEVICE_ENDPOINTS.list, query: { length: 100, graph_enc: stringifyGraph({ '*': true, branch: { name: true } }) } }), useBearerToken: true },
    })

  /** A 6-character code for a web till or the POS app to connect with, valid 10 minutes, for one branch. */
  public static readonly createLinkCode = async (body: DeviceLinkCodeRequest) =>
    this.createHttpRequest<DeviceLinkCode, ErrorBody>({
      correlationKey: this.correlations.CREATE_LINK_CODE,
      payload: { method: 'post', url: this.createEndpoint({ url: DEVICE_ENDPOINTS.linkCode }), body, useBearerToken: true },
    })

  public static readonly unlink = async (id: string) =>
    this.createHttpRequest<{ result: LinkedDevice }, ErrorBody>({
      correlationKey: this.correlations.UNLINK,
      payload: { method: 'delete', url: this.createEndpoint({ url: DEVICE_ENDPOINTS.unlink, params: { id } }), useBearerToken: true },
    })
}
